
import React from 'react';
import { IPreferencesService } from '@base/features/preferences/model/types';
import { container } from 'tsyringe';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import CheckboxSwitch from '@ui-kit/components/checkboxSwitch';
import styles from '../styles/preferencesControl.module.scss';

type Control = { title: string; key: string };

function GameControl(props: {additionalPreferences: Control[]}) {
  const gameControls: Control[]  = [
    {
      title: 'disallow_chat_while_playing',
      key: 'DISALLOW_CHAT_WHILE_PLAYING',
    },
    { title: 'allow_moves_with_dbl_click_dbl_tap', key: 'DOUBLE_CLICK_MOVE' },
  ].concat(props.additionalPreferences);

  const preferencesService: IPreferencesService<any> = container.resolve('preferencesService');
  const preferences = useBehaviorSubject(preferencesService.onPreferencesChanged);

  return (
    <div className={styles.preferencesControl}>
      {gameControls.map((preference) => (
        <CheckboxSwitch
          id={preference.key}
          key={preference.key}
          name={preference.key}
          checked={preferences[preference.key] as boolean}
          handler={(e) => preferencesService.updatePreferences(preference.key, e.target.checked)}
        >
          {t(preference.title)}
        </CheckboxSwitch>
      ))}
    </div>
  );
}

export default GameControl;
